import { useState, useEffect } from 'preact/hooks';
import { replaceAll, replaceData } from '../../../utilities/common';
import { actionHandler } from '../../../utilities/form/formUtils';
import { AnchorCheckbox as AnchorCheckboxLib } from "@tryg/react-ui-library";
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const AnchorCheckbox = (props) => {

    const {
        id,
        option,
        userData,
        translations,
        values,
        setValues,
        dispatch,
        onChange
    } = props;

    const {
        heading,
        label,
        variant,
        actions
    } = option;

    const [sofusConsentLabel, setSofusConsentLabel] = useState("");
    const [loadingConsents, setLoadingConsents] = useState(!userData.apiCallsStatus);

    const onToggledCheckbox = (e) => {
        //handle anchor event at beginning if any
        if(e.target.href && e.target.href !== "") {
            window.open(e.target.href, '_blank');
        }
        const newActive = e.target.checked;
        let currentId = e.target.name;
        if(!currentId) {
            currentId = e.currentTarget.attributes[0].value;
        }
        values[currentId] = newActive;
        //handle modal event if any
        const el = e.target.classList.contains("link__text");
        if (el && variant === "link") {
            actionHandler(actions, null, e, dispatch, values, setValues)
        }
        onChange(e);
        setValues({ ...values });
    }

    const getSofusConsentLabel = () => {
        if (userData.consents) {
            const value = userData.consents.templates.filter(item => item.templateName === replaceData(label, userData));
            if (value && value.length != 0) {
                setSofusConsentLabel(value[0].content);
            }
        }
    }

    useEffect(() => {
        if(userData.consents) {
            setLoadingConsents(false)
            getSofusConsentLabel();
        }
    }, [userData.consents]);

    return ( 
        <div>
            <AnchorCheckboxLib
                input-id={id}
                name={id}
                onToggled={e => onToggledCheckbox(e)}
                className="anchor-checkbox-hook"
                style={"--p-size-static-150: 0px;"}
                checked={
                    (Object.hasOwnProperty.call(values, id) && values[id] === true) ? true : false
                }
            >
                <strong>{ replaceAll(heading, translations, values) }</strong> 
                { loadingConsents ?  
                    <span 
                        slot="help-text" 
                        className='consents_loader'
                        >
                            <anchor-spinner size="small"/>
                    </span>
                    :
                    <span 
                        slot="help-text" 
                        dangerouslySetInnerHTML={
                            { __html: (sofusConsentLabel === "") ? replaceAll(label, translations, values) : sofusConsentLabel }
                        }>
                    </span>
                }
            </AnchorCheckboxLib>
        </div> 
    );
}

export default compose(
    connect(state => {
      const {
        section: {
          packageData: { translations },
        }
      } = state;
  
      return { translations };
    })
)(AnchorCheckbox);

AnchorCheckbox.defaultProps = {
    id: "", 
    type: "",
    option: {}
};
    
AnchorCheckbox.propTypes = {
    values: PropTypes.object.isRequired,
    translations: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    setValues: PropTypes.func.isRequired,
    userData: PropTypes.object.isRequired
};

